module.exports = __webpack_public_path__ + "6bc971daac771a23d563cce53bb2c85b.svg";